import { useAuth } from '@/hooks/useAuth';
import { ADMIN_ROLE_ID } from '@/lib/roles';

export default function SettingsPage() {
  const { profile, loading } = useAuth();
  const isAdmin = profile?.role_id === ADMIN_ROLE_ID;

  if (loading) {
    return (
      <div className="max-w-7xl">
        <div className="flex items-center gap-3">
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-loader-4-line text-lg text-primary-500 animate-spin"></i>
          </span>
          <span className="text-sm text-foreground-600">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-foreground-900 font-heading">設定</h2>
        <p className="text-sm text-foreground-600 mt-1">Beds24連携・スタッフ管理・通知設定</p>
      </div>

      <div className="bg-background-50 rounded-xl border border-background-200/70 p-12 text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-secondary-100 flex items-center justify-center">
          <i className="ri-settings-3-line text-2xl text-secondary-600"></i>
        </div>
        <h3 className="text-lg font-semibold text-foreground-900 mb-2">その他の設定</h3>
        <p className="text-sm text-foreground-600 max-w-md mx-auto">
          スタッフアカウント管理、通知設定などの追加設定機能はPhase 5で実装予定です。
        </p>
      </div>
    </div>
  );
}